<template>
  <v-row justify="center" v-if="notification && device">
    <v-dialog
      v-model="dialog"
      max-width="500"
      content-class="alert-confirm-dialog"
      overlay-opacity="0.8"
    >
      <v-card>
        <v-card-title :class="`text-h5 pa-5 bg-${color}`">
          <v-layout row wrap justify-center align-center>
            <v-icon size="36">mdi-bell</v-icon>
            <v-spacer></v-spacer>
            <v-card-title shrink>
              <div class="alert-title text-h4">
                {{ content.title }}
              </div>
            </v-card-title>
            <v-icon>none</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text class="text-center">
          <div class="my-8 fs-3">{{ notificationMessage }}</div>
          <v-divider></v-divider>
          <div class="d-flex fs-2">
            <strong id="device-name-label" class="tab-size fs-1">
              {{ content.deviceLabel }}
            </strong>
            <v-divider vertical></v-divider>
            <span id="device-name-value">{{ device.name }}</span>
          </div>
          <v-divider></v-divider>
          <div class="d-flex fs-2">
            <strong id="threshold-label" class="tab-size fs-1">
              {{ content.thresholdValueLabel }}
            </strong>
            <v-divider vertical></v-divider>
            <span
              id="threshold-value"
              v-if="notification.rule.sensor != 'hall'"
            >
              {{
                notification.rule.value +
                sensorsTitles[notification.rule.sensor]
              }}
            </span>
            <span id="threshold-value" v-else>
              {{
                parseInt(notification.rule.value) == "1"
                  ? $t("close")
                  : $t("open")
              }}
            </span>
          </div>
          <v-divider></v-divider>
          <div class="d-flex fs-2">
            <strong id="sensor-label" class="tab-size fs-1">
              {{ content.measuredValueLabel }}
            </strong>
            <v-divider vertical></v-divider>
            <span id="sensor-value" v-if="notification.rule.sensor != 'hall'">
              {{ notification.value + sensorsTitles[notification.rule.sensor] }}
            </span>
            <span id="threshold-value" v-else>
              {{
                parseInt(notification.value) == "1" ? $t("close") : $t("open")
              }}
            </span>
          </div>
          <v-divider></v-divider>
          <div class="mt-4 fs-1">
            {{ content.confirmMessage }}
          </div>
          <div class="mt-4">
            <small>
              {{ content.createdAtLabel }} -
              {{ new Date(notification.created_at).toLocaleString() }}
            </small>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            text
            color="success"
            :loading="loading"
            @click="confirmNotification"
            class="fs-3"
          >
            {{ content.confirmButton }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import Lang from "@/helpers/lang";
export default {
  name: "ConfirmNotification",
  props: ["activator", "notification"],
  data() {
    return {
      dialog: false,
      locale: null,
      sensorNames: "",
      notificationMessage: "",
      color: "danger",
      loading: false,
      sensorsTitles: {
        range: "cm",
        temperatures: "°C",
        humidity: "%",
        co2: "ppm",
        pressure: "hPa",
      },
    };
  },

  created() {
    this.dialog = this.activator;
    this.locale = Lang.get();
    this.setLang();
  },
  computed: {
    device() {
      return this.$store.getters["devices/device"](
        this.notification.device_slug
      );
    },
  },
  // destroyed() {
  //   console.log("destroyed confirm notification");
  // },
  watch: {
    activator() {
      this.dialog = this.activator;
    },
    locale: {
      handler() {
        this.setLang();
        this.generateNotification();
      },
    },
  },
  methods: {
    async confirmNotification() {
      this.loading = true;
      await this.$store.dispatch(
        "notifications/confirmNotification",
        this.notification.slug
      );
      this.close();
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.$emit("close");
    },
    setLang() {
      if (!this.locale) this.locale = Lang.get();
      if (this.locale == "en") {
        this.content = {
          title: "Device Alert",
          deviceLabel: "Device",
          alertTypeLabel: "Alert Type",
          thresholdTypeLabel: "Threshold Type",
          thresholdValueLabel: "Threshold Value",
          measuredValueLabel: "Measured Value",
          createdAtLabel: "The original alert was created on",
          confirmMessage:
            "Please confirm receipt of this notification to stop further repeated alerts.",
          confirmButton: "Confirm Viewing",
          notifications: {
            OnlineDevice: {
              message: "The sensor has reconnected",
              color: "light-blue",
            },
            OfflineDevice: {
              message: "The sensor has lost connection",
              color: "warning",
            },
            ReturnedToNormalAbove: (sensor) =>
              `The sensor '${sensor}' has returned to normal below the upper threshold`,
            ReturnedToNormalBelow: (sensor) =>
              `The sensor '${sensor}' has returned to normal above the lower threshold`,
            ExceedsThresholdAbove: (sensor) =>
              `The sensor '${sensor}' exceeds the upper threshold`,
            ExceedsThresholdBelow: (sensor) =>
              `The sensor '${sensor}' exceeds the lower threshold`,
            MagnetOpen: (sensor) => `The sensor '${sensor}' is open`,
            MagnetClose: (sensor) => `The sensor '${sensor}' is close`,
          },
        };
      } else if (this.locale == "he") {
        this.content = {
          title: "התראה במכשיר",
          deviceLabel: "מכשיר",
          alertTypeLabel: "סוג התראה",
          thresholdTypeLabel: "סוג סף",
          thresholdValueLabel: "ערך סף",
          measuredValueLabel: "ערך נמדד",
          createdAtLabel: "ההתראה המקורית נוצרה ב",
          confirmMessage: "אנא אשר את קבלת ההודעה על מנת להפסיק התראות חוזרות.",
          confirmButton: "אישור צפייה",
          notifications: {
            OnlineDevice: { message: "החיישן חידש חיבור", color: "fine" },
            OfflineDevice: { message: "החיישן איבד חיבור", color: "warning" },
            ReturnedToNormalAbove: (sensor) =>
              `החיישן '${sensor}' חזר למצב תקין מתחת לסף העליון`,
            ReturnedToNormalBelow: (sensor) =>
              `החיישן '${sensor}' חזר למצב תקין מעל לסף התחתון`,
            ExceedsThresholdAbove: (sensor) =>
              `החיישן '${sensor}' חורג מהסף העליון`,
            ExceedsThresholdBelow: (sensor) =>
              `החיישן '${sensor}' חורג מהסף התחתון`,
            MagnetOpen: (sensor) => `החיישן '${sensor}' פתוח`,
            MagnetClose: (sensor) => `החיישן '${sensor}' סגור`,
          },
        };
      }
    },
    generateNotification() {
      const { type, rule } = this.notification;
      const sensorName = this.device.name ?? "some name";
      const notifications = this.content.notifications;

      switch (type) {
        case "OnlineDevice":
        case "OfflineDevice":
          this.notificationMessage = notifications[type].message;
          this.color = notifications[type].color;
          break;
        case "ReturnedToNormal":
          this.notificationMessage =
            rule.action === ">"
              ? notifications.ReturnedToNormalAbove(sensorName)
              : notifications.ReturnedToNormalBelow(sensorName);
          break;
        case "ExceedsThreshold":
          this.notificationMessage =
            rule.action === ">"
              ? notifications.ExceedsThresholdAbove(sensorName)
              : notifications.ExceedsThresholdBelow(sensorName);
          break;
        case "MagnetNotification":
          this.notificationMessage =
            parseInt(rule.value) == 1
              ? notifications.MagnetOpen(sensorName)
              : notifications.MagnetClose(sensorName);
          break;
        default:
          this.notificationMessage = "Unknown notification type";
      }
      // console.log("this.notificationMessage", this.notification);
    },
  },
};
</script>
<style lang="scss">
.alert-confirm-dialog {
  background: #000;
  border-radius: 20px;
}
</style>
<style lang="scss" scoped>
.alert-title {
  white-space: pre-wrap;
  word-break: break-word;
  text-align: center;
}
.fs-1 {
  font-size: 1.1em;
}
.fs-2 {
  font-size: 1.3em;
  line-height: 2;
}
.fs-3 {
  font-size: 1.5em;
  line-height: 2;
}
.tab-size {
  width: 100%;
  min-width: 100px;
  text-align: center;
}
span {
  white-space: pre-wrap;
  word-break: break-word;
  width: 100%;
  text-align: center;
}
.bg-warning {
  background-color: #ffc107;
  .alert-title {
    color: #444;
  }
  .v-icon {
    color: #fff;
  }
}
.bg-danger {
  background-color: rgba(190, 20, 17, 0.5);
  .v-icon {
    color: rgba(190, 20, 17, 1);
  }
  .alert-title {
    text-shadow: 1px 1px 4px rgb(51, 44, 44), 0 0 1em #be14117e,
      0 0 0.2em #be14117e;
    color: #fff;
  }
}
.v-icon {
  margin: 0 auto;
}
.v-dialog > .v-card > .v-card__actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
#device-name-label {
  color: #440072;
}
#device-name-value {
  color: #ae3ff9;
}
#threshold-label {
  color: #6e3000;
}
#threshold-value {
  color: #ff8f00;
}
#sensor-label {
  color: #5a0000;
}
#sensor-value {
  color: #e53935;
}
</style>
